import OtpVerification from './otpverification';
import { Button, Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { APIUtils } from '../../../../utils/apiutils';
import httpClient from '../../../../services/http';
import { CUSTOM_EVENTS } from '../../../../utils/constants';
import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import { CgSpinner } from 'react-icons/cg';
import { useAppointmentDetailsContext } from '../contexts/appointmentdetails.context';

function MarkAsComplete() {
    const { appointmentDetails: appointment } = useAppointmentDetailsContext();
    const [openOtpDialog, setOpenOtpDialog] = useState(false);
    const [loading, setLoading] = useState(false);

    const toggleOtpDialog = (toggle) => () => {
        if (toggle) {
            generateOtp();
            return;
        }
        setOpenOtpDialog(toggle);
    };

    const generateOtp = async () => {
        try {
            const url = APIUtils.getAdminAPIEndpoint('generate-appointment-completion-otp');
            const body = {apptId: appointment.id};
            setLoading(true);
            const res = await httpClient.post(url, body).then(res => res.data);
            if (res.status === 'success') {
                setOpenOtpDialog(true);
            } else {
                Swal.fire('Something Went Wrong!', '', 'error');
            }
            setLoading(false);
        } catch (error) {
            if (error?.cause?.response?.data?.message) {
                Swal.fire('Sorry!', error.cause.response.data.message, 'error');
                setLoading(false);
                return;
            }
            Swal.fire('Something Went Wrong!', '', 'error');
        }
    };

    // Register event for prescription dialog toggle
    useEffect(() => {
        const toggleOtpDialog = (e) => {
            const data = e.detail;
            setOpenOtpDialog(data);
        };
        document.addEventListener(CUSTOM_EVENTS.TOGGLE_OTP_DIALOG, toggleOtpDialog);
        return () => {
            document.removeEventListener(CUSTOM_EVENTS.TOGGLE_OTP_DIALOG, toggleOtpDialog);
        };
    }, []);

    const otpDialog = openOtpDialog && <Dialog open={openOtpDialog} maxWidth='xs' fullWidth>
        <DialogTitle sx={{ display: 'flex', alignItems: 'center' }}>
            <div style={{ flex: 1 }}>OTP</div>
            <IconButton size='small' onClick={toggleOtpDialog(false)}>
                <CloseOutlinedIcon />
            </IconButton>
        </DialogTitle>
        <DialogContent>
            <OtpVerification />
        </DialogContent>
    </Dialog>;

    const btnUI = () => {
        if (loading) {
            return <>
                Generating OTP...&nbsp;<CgSpinner size={20} className='mt-1 animate-spin' />
            </>;
        }
        return 'Mark as Complete';
    };

    const btnDisabled = loading;

    return <>
        {otpDialog}
        <Button variant='contained' color='warning' disabled={btnDisabled} onClick={toggleOtpDialog(true)}>{btnUI()}</Button>
    </>;
}

export default MarkAsComplete;